(function () {
  function hideBanners() {
    ["lana-pwa-bar", "lana-apk-banner"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.remove();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hideBanners);
  } else {
    hideBanners();
  }
})();
